import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { useLightboxStore } from "@/stores/ui";

// Uses Radix Dialog directly (not our ui/dialog wrapper) so we can lay out a
// borderless full-bleed image with a custom overlay. Nested Radix dialogs
// automatically promote the topmost one as "active" — outside-click /
// pointer-down events do NOT bubble to underlying dialogs (e.g. SamplesModal).
export function Lightbox() {
  const url = useLightboxStore((s) => s.url);
  const close = useLightboxStore((s) => s.hide);

  return (
    <DialogPrimitive.Root open={!!url} onOpenChange={(v) => !v && close()}>
      <DialogPrimitive.Portal>
        {/* z-[100] so the lightbox always covers SamplesModal / StyleModal */}
        <DialogPrimitive.Overlay className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-md data-[state=open]:animate-in data-[state=open]:fade-in-0" />
        <DialogPrimitive.Content
          aria-describedby={undefined}
          className="fixed inset-0 z-[100] flex items-center justify-center p-6 focus:outline-none data-[state=open]:animate-in data-[state=open]:fade-in-0"
          // Click on the backdrop area (this Content itself, NOT a child) closes.
          onClick={(e) => {
            if (e.target === e.currentTarget) close();
          }}
        >
          <DialogPrimitive.Title className="sr-only">图片预览</DialogPrimitive.Title>
          <DialogPrimitive.Close
            className="absolute right-5 top-5 inline-flex items-center gap-2 rounded-full border border-border bg-card px-4 py-1.5 text-sm text-foreground transition-colors hover:bg-secondary"
            aria-label="关闭"
          >
            <X className="h-3.5 w-3.5" />
            关闭
          </DialogPrimitive.Close>
          {url && (
            <img
              src={url}
              alt="预览"
              className="max-h-[86vh] max-w-[90vw] rounded-lg shadow-2xl"
              onClick={(e) => e.stopPropagation()}
              onError={() => close()}
            />
          )}
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}
